import { render, staticRenderFns } from "./e_dataDetails.vue?vue&type=template&id=707a5102&scoped=true&"
import script from "./e_dataDetails.vue?vue&type=script&lang=js&"
export * from "./e_dataDetails.vue?vue&type=script&lang=js&"
import style0 from "./e_dataDetails.vue?vue&type=style&index=0&id=707a5102&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707a5102",
  null
  
)

export default component.exports